import { Controller } from "@hotwired/stimulus"

// Preserves the sidebar's scroll position across Turbo navigations, so clicking
// a menu item near the bottom doesn't jump the nav back to the top. The nav is
// still re-rendered each visit (so the active highlight updates); we just
// restore where it was scrolled to.
const KEY = "bizsuite:navscroll"

export default class extends Controller {
  connect() {
    const saved = sessionStorage.getItem(KEY)
    if (saved !== null) this.element.scrollTop = parseInt(saved, 10)
    this.onScroll = () => sessionStorage.setItem(KEY, this.element.scrollTop)
    this.element.addEventListener("scroll", this.onScroll, { passive: true })
  }

  disconnect() {
    this.element.removeEventListener("scroll", this.onScroll)
  }
}
